import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/reglementsarbitrage`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

/// GET
// Fonction pour afficher tous les règlements d'arbitrage
export const getReglementsArbitrage = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allreglement`, {
      headers: {
        ...authHeaders(),
      },
    });

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(
      "Erreur lors du chargement des règlements d'arbitrage:",
      error
    );
    return [];
  }
};

/// POST
// Fonction pour créer un règlement d'arbitrage
export const createReglementArbitrage = async (reglement) => {
  try {
    const payload = {
      title: reglement?.title || "",
      content: reglement?.content || "",
      lien_url: reglement?.lien_url || null,
      lien_url_image: reglement?.lien_url_image || null,
      display_order:
        reglement?.display_order !== undefined &&
        reglement?.display_order !== null &&
        reglement?.display_order !== ""
          ? Number(reglement.display_order)
          : undefined,
    };

    const response = await axios.post(`${apiUrl}/addreglement`, payload, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la création du règlement d'arbitrage:",
      error
    );
    return null;
  }
};

/// PUT
// Fonction pour modifier un règlement d'arbitrage
export const updateReglementArbitrage = async (reglement) => {
  try {
    const payload = {
      title: reglement?.title || "",
      content: reglement?.content || "",
      lien_url: reglement?.lien_url || null,
      lien_url_image: reglement?.lien_url_image || null,
      display_order:
        reglement?.display_order !== undefined &&
        reglement?.display_order !== null &&
        reglement?.display_order !== ""
          ? Number(reglement.display_order)
          : undefined,
    };

    const response = await axios.put(
      `${apiUrl}/updatereglement/${reglement.id}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la modification du règlement d'arbitrage:",
      error
    );
    return null;
  }
};

/// DELETE
// Fonction pour supprimer un règlement d'arbitrage
export const deleteReglementArbitrage = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deletereglement/${id}`, {
      headers: {
        ...authHeaders(),
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression du règlement d'arbitrage:",
      error
    );
    return null;
  }
};

/// PUT
// Fonction pour réordonner les règlements d'arbitrage
export const reorderReglementsArbitrage = async (items = []) => {
  try {
    const payload = {
      items: items.map((item, index) => ({
        id: Number(item.id),
        display_order:
          item?.display_order !== undefined
            ? Number(item.display_order)
            : index + 1,
      })),
    };

    const response = await axios.put(`${apiUrl}/reorder`, payload, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
    });

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(
      "Erreur lors du réordonnancement des règlements d'arbitrage:",
      error
    );
    return [];
  }
};